import { QuestionSuggestion } from '@finect/tabular-components/QuestionSuggestion';
import { suggestionStrategy } from './suggestionStrategy';
export var questionSuggestion = {
  strategy: suggestionStrategy,
  component: QuestionSuggestion
};